import { CHECKLIST } from "Constants/stringConstants";
import React, { PureComponent } from "react";
import AssessmentToolAccordionTable from "AppComponents/AssessmentToolAccordionTable";

import CheckListEdit from "./CheckListEdit";
import CheckListView from "./CheckListView";
import { getAssessmentToolStyles } from "ClassRoom/modules/utils";
import { connect } from "react-redux";
import ChecklistEditWithReordering from "./ChecklistEditWithReordering";

class ChecklistTable extends PureComponent {
  render() {
    const {
      checklist = {},
      mode,
      isSplitView = false,
      isEnabledAssessmentToolReordering = false,
    } = this.props;

    const { checklistItems, checklistOptionItems } = checklist;

    const assessmentTool = {
      indicators: checklistItems,
      criterias: checklistOptionItems,
    };

    if (mode === "view") {
      if (isSplitView) {
        return (
          <AssessmentToolAccordionTable
            {...this.props}
            assessmentTool={assessmentTool}
            toolType={CHECKLIST}
          />
        );
      } else {
        return <CheckListView {...this.props} />;
      }
    } else {
      if (isEnabledAssessmentToolReordering) {
        return <ChecklistEditWithReordering {...this.props} />;
      } else {
        return <CheckListEdit {...this.props} />;
      }
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { uiType } = ownProps;
  const { checklistStyles = {} } = getAssessmentToolStyles({ uiType });

  return {
    ...checklistStyles,
  };
};

export default connect(mapStateToProps, null)(ChecklistTable);

ChecklistTable.defaultProps = {
  isEvaluation: false,
  showInsight: false,
  insights: [],
  toolEvaluationResponses: [],
};
